.biel-search-header-container {
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--biel-header-border-color);
  margin-bottom: 10px;
  padding-bottom: 10px;
}

biel-search-input {
  flex: 1;
  min-width: 0;
}

.header-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: 8px;
  gap: 4px;
}

.action-button {
  position: relative;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  color: var(--biel-header-text-color);
}

.action-button:hover {
  opacity: 0.7;
}

@media screen and (max-width: 768px) {
  .action-button--expand {
    display: none;
  }
}

.action-button svg {
  width: 18px;
  height: 18px;
  color: var(--biel-header-text-color);
}

.action-button__tooltip {
  position: absolute;
  bottom: -28px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #333;
  color: #fff;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  z-index: 1000;
}

.action-button__tooltip::before {
  content: '';
  position: absolute;
  top: -3px;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #333;
}

.action-button:hover .action-button__tooltip {
  opacity: 1;
}

.biel-search-header__filters-container {
  overflow-x: auto;
  margin-bottom: 6px;
}

.biel-search-header__filters-container::-webkit-scrollbar {
  height: 0;
}

@media screen and (min-width: 768px) {
  .biel-search-header__filters-container::-webkit-scrollbar {
    height: 6px;
  }

  .biel-search-header__filters-container::-webkit-scrollbar-thumb {
    background-color: var(--biel-chat-scrollbar-color);
    border-radius: 10px;
    border: 1px solid transparent;
  }

  .biel-search-header__filters-container::-webkit-scrollbar-thumb:hover {
    background-color: var(--biel-chat-scrollbar-hover-color);
  }
}
